import { render, staticRenderFns } from "./AddNewClinicianStaff.vue?vue&type=template&id=351a5082&"
import script from "./AddNewClinicianStaff.vue?vue&type=script&lang=js&"
export * from "./AddNewClinicianStaff.vue?vue&type=script&lang=js&"
import style0 from "./AddNewClinicianStaff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports